<p-dialog [(visible)]="displayModal" 
[modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false" [closeOnEscape]="false"
    class="confirmation-dialogue {{customClass}}">
    <ng-template pTemplate="header">{{title}}</ng-template>
    <span class="p-confirm-dialog-message">
        
        <p><img alt="warningImage" class="warning-img" *ngIf="isExceptionModal" src="{{assetsUrl}}noun_Warning_3775442.png"> {{message || 'Are you sure you want to delete?'}}</p>
    </span>
    <ng-template pTemplate="footer">
        <div class="btnHolder">
            <button type="button" class="primaryBtn" (click)="confirm()">
                <img alt="tickImage" src="{{assetsUrl}}tick (3).png"> {{okBtnLabel}}</button>
            <button type="button" class="SecondaryBtn" (click)="cancel()" *ngIf="isCancelBtnVisible">
                <img alt="closeImage" src="{{assetsUrl}}close (1).png"> {{cancelBtnLabel}}</button>
        </div>
    </ng-template>
</p-dialog>